export const DATA_SOURCE_IDS = {
  APPS: 'measure_apps',
  BROWSER: 'measure_browsing',
  CAMPAIGN: 'campaign',
  DISCOVER: 'discover',
  INSTAGRAM: 'measure_instagram',
  INSTAGRAM_FOLLOWS: 'instagram_follows',
  SAVED_QUERIES: 'saved',
  TWITTER: 'twitter',
} as const;

export const DATA_SOURCE_LABELS = {
  APPS: 'App',
  BROWSER: 'Web Browsing',
  CAMPAIGN: 'Campaigns',
  DISCOVER: 'Discover',
  INSTAGRAM: 'Instagram',
  INSTAGRAM_FOLLOWS: 'Instagram',
  SAVED_QUERIES: 'Saved',
  TWITTER: 'Social',
} as const;

export const dataSourceLabelMap = Object.fromEntries(
  Object.entries(DATA_SOURCE_IDS).map(([labelKey, sourceId]) => [
    sourceId,
    DATA_SOURCE_LABELS[labelKey],
  ])
);

export const DATA_SOURCE_COLORS = {
  APPS: 'green',
  BROWSER: 'violet',
  TWITTER: 'blue',
  INSTAGRAM: 'pink',
  INSTAGRAM_FOLLOWS: 'pink',
} as const;

export const DATA_SOURCE_COLOR_RGB_MAP = {
  [DATA_SOURCE_IDS.APPS]: 'rgb(7, 131, 117)',
  [DATA_SOURCE_IDS.BROWSER]: 'rgb(91, 83, 223)',
  [DATA_SOURCE_IDS.TWITTER]: 'rgb(23, 121, 204)',
  [DATA_SOURCE_IDS.INSTAGRAM]: 'rgb(225, 40, 87)',
  [DATA_SOURCE_IDS.INSTAGRAM_FOLLOWS]: 'rgb(225, 40, 87)',
} as const;

export const DATA_SOURCE_ICONS = {
  APPS: 'app',
  BROWSER: 'web',
  CAMPAIGN: 'icon-play',
  CONVERSATION: 'conversation',
  DISCOVER: 'discover',
  FOLDER: 'folder',
  INSTAGRAM: 'instagram',
  INSTAGRAM_FOLLOWS: 'instagram',
  SEGMENTATION: 'segmentation',
  SPINNER: 'spinner',
  TSV: 'users',
  TWITTER: 'social',
  SAVED_QUERIES: 'saved',
} as const;

export const dataSourceIconMap = Object.fromEntries(
  Object.entries(DATA_SOURCE_IDS).map(([iconKey, sourceId]) => [
    sourceId,
    DATA_SOURCE_ICONS[iconKey as keyof typeof DATA_SOURCE_ICONS] || '',
  ])
) as Record<string, string>;

export const dataSourceMap = Object.fromEntries(
  Object.entries(DATA_SOURCE_IDS).map(([key, sourceId]) => [
    sourceId,
    [
      DATA_SOURCE_LABELS[key as keyof typeof DATA_SOURCE_LABELS] || '',
      DATA_SOURCE_ICONS[key as keyof typeof DATA_SOURCE_ICONS] || '',
    ],
  ])
) as Record<string, [string, string]>;

